module.exports = __webpack_public_path__ + "static/media/menuimage_stadtticket.8ee7d087.jpg";